import { render } from "./FotoUsuario.vue?vue&type=template&id=090b44ee&scoped=true"
import script from "./FotoUsuario.vue?vue&type=script&lang=js"
export * from "./FotoUsuario.vue?vue&type=script&lang=js"

import "./FotoUsuario.vue?vue&type=style&index=0&id=090b44ee&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090b44ee"],['__file',"src/components/Usuario/FotoUsuario.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "090b44ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('090b44ee', __exports__)) {
    console.log('reload')
    api.reload('090b44ee', __exports__)
  }
  
  module.hot.accept("./FotoUsuario.vue?vue&type=template&id=090b44ee&scoped=true", () => {
    console.log('re-render')
    api.rerender('090b44ee', render)
  })

}


export default __exports__